export default {
    namespaced: true,
    state: {
        info:{}
    },
    getters: {
    },
    mutations: {
        setInfo(state, payload) {
            state.info = payload
        },
        
    },
    actions: {
    },

}